require('./bootstrap');

import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { usePage } from '@inertiajs/inertia-vue3';
import { createApp, h } from 'vue';
import store from './Store'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
/* import specific icons */
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons';

// import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { DateTime } from "luxon";
library.add(fas, far)

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const toCurrency = function (value) {
    value = Number(value);
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
};

const roundDecimals = function (value) {
    return Math.round(value * 100) / 100;
};

const filterNumberInput = function (e) {
    if (e.key === 'e') return e.preventDefault();
};

const formatDate = (date, format = 'MMM d, yyyy') => {
    if (!date) {
        return '-';
    }
    const parsedDate = new Date(date + 'T00:00:00');

    return DateTime.fromISO(parsedDate.toISOString()).toFormat('MMM d, yyyy');
};

const formatTimestamp = (timestamp, format = 'MMM. d, yyyy h:mm a') => {
    if (!timestamp) {
        return null;
    }

    let date = DateTime.fromSQL(timestamp).invalid ? DateTime.fromISO(timestamp) : DateTime.fromSQL(timestamp);

    return date.toFormat(format);
};

const openInNewTab = (url) => {
    window.open(url, '_blank')
}

const shouldAutoprint = (printType = null) => {
    let autoprintEnabled = usePage().props.value.autoprintEnabled;
    let autoprintTypes = ['labels'];

    return autoprintEnabled && autoprintTypes.includes(printType);
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(store)
            .mixin({
                methods: { route, toCurrency, roundDecimals, formatDate, formatTimestamp, openInNewTab, shouldAutoprint },
                directives: {
                    numbers: {
                        beforeMount: function (el) {
                            el.addEventListener('keydown', filterNumberInput);
                        },
                        beforeUnmount: function(el) {
                            el.removeEventListener('keydown', filterNumberInput);
                        }
                    },
                },
            })
            .component('font-awesome-icon', FontAwesomeIcon)
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });
